const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development'

function isLocalhost () {
  if (typeof window === 'undefined') return false
  const h = window.location && window.location.hostname
  return h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0'
}

const CONFIG = {
  production: {
    API_ENDPOINT: 'https://api.getmalus.com/api',
  },
  development: {
    API_ENDPOINT: 'http://localhost:5000/api',
    // API_ENDPOINT: 'https://api.getmalus.com/api',
    // API_ENDPOINT: 'http://localhost:3000/api',
  },
  test: {
    API_ENDPOINT: 'http://192.168.111.244:5000/api',
  },
  staging: {
    API_ENDPOINT: 'https://stg-402.getmalus.com/api',
  },
}

module.exports = {
  ENV,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || (isLocalhost() ? (process.env.REACT_APP_LOCAL_API_ENDPOINT || 'http://localhost:5000/api') : CONFIG[ENV].API_ENDPOINT),
}
